/* Angular Component */
import {
  Component,
  Output,
  Input,
  EventEmitter,
  ElementRef,
  NgZone,
} from "@angular/core";

const ARROW_DOWN = 40;
const ARROW_UP = 38;
const ENTER = 13;

@Component({
  selector: "autocomplete",
  templateUrl: "./autocomplete.component.html",
  styleUrls: ["./autocomplete.component.scss"],
  host: {
    "[class.top]": "position === 'top'",
    "[class.bottom]": "position === 'bottom'",
  },
})
export class AutocompleteComponent {
  @Input()
  values = [];

  @Input()
  excludes = [];

  @Input()
  key;

  @Input()
  visible = false;

  @Input()
  inputLabel;

  @Input()
  inputPlaceholder;

  @Input()
  feedWithEnter = false;

  @Input()
  position: "top" | "bottom" = "bottom";

  @Output()
  output = new EventEmitter();

  @Output()
  outputNewValue = new EventEmitter();

  relatedInput;
  lastIndexFocus = undefined;
  inputValue;

  selectedSuggestion = -1;
  suggestions = [];

  constructor(
    private ref: ElementRef,
    private zone: NgZone,
  ) {}

  ngOnInit() {
    this.lastIndexFocus = undefined;
  }

  /**
   * When input receives focus - show all available options
   * @param data
   */
  onInputFocus(data) {
    this.suggestions = [...this.values];
    this.visible = this.suggestions.length > 0;
    this.lastIndexFocus = undefined;
    this.selectedSuggestion = -1;
  }

  /**
   * When input become blur
   * @param value
   */
  onInputBlur(value) {
    console.log("autocomplete-> onInputBlur");

    this.visible = false;
  }

  /**
   * Handler for KeyUp process (Lookup)
   * @param data
   * @return void
   */
  onInputKeyup(data) {
    /* Don't waste time */
    if (typeof data.data == "undefined") return;

    this.inputValue = data.data;
    this.visible = false;

    let event = data.event;

    if (event.which == ENTER) {
      this.onEnter();
      return;
    }

    /* Moving Down */
    if (event.which == ARROW_DOWN) {
      this.onUserClickArrowDown();
      return;
    }

    /* Moving Up */
    if (event.which == ARROW_UP) {
      this.onUserClickArrowUp();
      return;
    }

    this.suggestions = this.getSuggestions(data.data);

    if (this.suggestions.length > 0) {
      this.visible = true;
    }
    this.lastIndexFocus = undefined;
    this.selectedSuggestion = -1;
  }

  getSuggestions(data: string) {
    const suggestions = [];

    this.values.forEach((item) => {
      let value = this.key ? item[this.key] : item;
      if (value && value.toLowerCase().includes(data.toLowerCase())) {
        suggestions.push(item);
      }
    });
    return suggestions;
  }

  onUserClickArrowDown() {
    if (typeof this.lastIndexFocus == "undefined") {
      this.lastIndexFocus = 0;
    } else {
      /* Prevent View Lose */
      if (!this.suggestions[this.lastIndexFocus + 1]) return;

      /* Increase position */
      this.lastIndexFocus++;
    }

    this.selectedSuggestion = this.lastIndexFocus;

    this.inputValue = this.formatSuggestion(
      this.suggestions[this.lastIndexFocus],
    );
  }

  onUserClickArrowUp() {
    if (typeof this.lastIndexFocus == "undefined") return;

    /* Prevent View Lose */
    if (this.lastIndexFocus == 0) {
      this.selectedSuggestion = -1;
      return;
    }

    /* Decrease position */
    this.lastIndexFocus--;

    /* Reset Selected Rows */
    this.selectedSuggestion = this.lastIndexFocus;

    this.inputValue = this.formatSuggestion(
      this.suggestions[this.lastIndexFocus],
    );
  }

  onEnter() {
    if (typeof this.lastIndexFocus == "undefined") {
      this.outputNewValue.emit(this.inputValue);
      this.inputValue = "";
      this.visible = false;
      return;
    }

    this.sendOutput(this.suggestions[this.lastIndexFocus]);
  }

  /**
   * Sending Out Value In case of Mouse Click
   * @param event
   */
  selectElement(valueIndex) {
    this.sendOutput(this.values[valueIndex]);
  }

  /**
   * Sending Out the supplied Values (if reached by click [enter] or mouse click)
   * @param value
   * @return void
   */
  sendOutput(value) {
    this.output.emit(value);
    this.inputValue = "";
    this.visible = false;
  }

  formatSuggestion(suggestion) {
    return this.key ? suggestion[this.key] : suggestion;
  }
}
